
import { Component, Mixins, Emit } from "vue-property-decorator";
import { DomainRegistry } from "../../../domain";
import { default as WorkflowCommonMixin } from "./WorkflowCommonMixin.vue";
import { WorkflowActionContent, ReceptionSaveResult } from "../../../domain/workflow";
import { ReceptionComment } from "../../../domain/workflow/reception";
import { ButtonInfo, WorkflowDestination } from "../../../domain/workflow/items";

@Component({
})
export default class WorkflowActionBaseMixin extends Mixins(WorkflowCommonMixin) {

  @Emit()
  wfaction(): void {}

  @Emit()
  startLoading(): void {}

  @Emit()
  stopLoading(): void {}


  data(): any {
    return {
    };
  }

  execWorkflowAction(receptionDetailId: number, permission: ButtonInfo, destination: WorkflowDestination, nextMessage: string, backMessage: string, lastWorkflowHistoryId: string, nextMessageCommentId?: number, nextMessageArchiveId?: number): Promise<ReceptionSaveResult> {
    const action = new WorkflowActionContent();
    action.triggerCode = permission.triggerCode;
    action.destination = destination;
    action.nextMessageCommentId = nextMessageCommentId;
    action.nextMessageArchiveId = nextMessageArchiveId;
    action.nextMessage = nextMessage;
    action.backMessage = backMessage;
    action.lastWorkflowHistoryId = lastWorkflowHistoryId;

    const repository = DomainRegistry.workflow.getWorkflowRepository();
    return repository.doWorkflowAction(receptionDetailId, action);
  }

  async getCommentByDetailIdAndCommentType(detailId: number, type: string): Promise<ReceptionComment> {
    try {
      const repository = DomainRegistry.workflow.getWorkflowRepository();
      const result = await repository.getCommentByDetailIdAndCommentType(detailId, type);
      return result;
    } catch (e) {
      this.$error("最新コメント取得失敗", "最新のコメント取得に失敗しました。", e);
    }
  }

  async reeditComment(title: string, label: string, editingComment: string, latestComment: ReceptionComment): Promise<string> {
    return this.$commonDialogs.workflow.conflictCommentComparer.show(
      title,
      label,
      editingComment,
      latestComment
    );
  }
}
